import React from 'react';
import { ICONIFY } from '../../../Constants/iconify';
import { Stack } from '@mui/material';
import OptionsNode from './OptionsNode';
import NodeWrapper from './NodeWrapper';

function RadioNode({ data }) {

    return (
        <NodeWrapper nodeId={data?.id}>
            <OptionsNode data={data} icon={ICONIFY.RADIO} />
        </NodeWrapper>
    )
};

export default React.memo(RadioNode)